module.exports = __webpack_public_path__ + "img/wheel_field_jackpot.e95e2b84.png";